import { CidMobileErrorMapProtocols } from './clientProtocols';

const {
  CidErrGeneralLicenseError,
  CidErrLicenseExpired,
  CidErrEmrNotConfigured,
  CidErrIdProofingIncomplete,
  CidErrInvalidAudience,
  CidErrInvalidPartnerAppName,
  CidErrInvalidPartnerName,
  CidErrInternalError,
  CidErrUserDisabled,
  CidErrUserExpired,
  CidErrUserNotFound,
  CidErrUserLocked,
  CidErrUsernameNotUnique,
  CidErrPasswordExpired,
  CidErrWorkflowNotAssigned,
  CidErrInvalidWorkflow,
  CidErrModalityNotAllowed,
  CidErrModalityNotEnrolled,
  CidErrAuthTimeOut,
} = CidMobileErrorMapProtocols;

// Note: the keys in this file are only known mobile EPCS error codes for the partner app.

let cidMobileErrorMap = new Map();

const standardErrorText = 'Unable to complete signing. Try again or contact your help desk. Imprivata: ';

// uses feature name
const featureName = 'Mobile EPCS';
const licenseExpiredError = `${standardErrorText} Not licensed for ${featureName}`;
cidMobileErrorMap.set(CidErrGeneralLicenseError.asString, licenseExpiredError);
cidMobileErrorMap.set(CidErrLicenseExpired.asString, licenseExpiredError);

// misc errors
cidMobileErrorMap.set(CidErrEmrNotConfigured.asString, standardErrorText + 'EMR not configured.');
cidMobileErrorMap.set(CidErrIdProofingIncomplete.asString, 'Imprivata: You must complete the identity proofing process. Contact your help desk.');
cidMobileErrorMap.set(CidErrInvalidAudience.asString, standardErrorText + 'Invalid audience.');
cidMobileErrorMap.set(CidErrInvalidPartnerAppName.asString, standardErrorText + 'Invalid partner app name.');
cidMobileErrorMap.set(CidErrInvalidPartnerName.asString, standardErrorText + 'Invalid partner name.');

// need to add log id number?
cidMobileErrorMap.set(CidErrInternalError.asString, standardErrorText + '{transactionId}');

// User errors
cidMobileErrorMap.set(CidErrUserDisabled.asString, standardErrorText + 'Account disabled.');
cidMobileErrorMap.set(CidErrUserExpired.asString, standardErrorText + 'Account expired.');
cidMobileErrorMap.set(CidErrUserNotFound.asString, standardErrorText + 'User not found.');
cidMobileErrorMap.set(CidErrUserLocked.asString, standardErrorText + 'Account locked.');
cidMobileErrorMap.set(CidErrUsernameNotUnique.asString, standardErrorText + 'User not found.');
cidMobileErrorMap.set(CidErrPasswordExpired.asString, 'Imprivata: Your password has expired. Contact your help desk.');

// uses workflow name
cidMobileErrorMap.set(CidErrWorkflowNotAssigned.asString, standardErrorText + '{workflowName} not enabled.');
cidMobileErrorMap.set(CidErrInvalidWorkflow.asString, standardErrorText + '{workflowName} not enabled.');
cidMobileErrorMap.set(CidErrModalityNotAllowed.asString, standardErrorText + 'Authentication methods for {workflowName} are not available.');
cidMobileErrorMap.set(CidErrModalityNotEnrolled.asString, standardErrorText + 'Authentication methods for {workflowName} are not available.');

// AuthTimeOut
const AuthTimeOutError = standardErrorText + 'Too much time has passed. Try again.';
cidMobileErrorMap.set(CidErrAuthTimeOut.asString, AuthTimeOutError);
cidMobileErrorMap.set('AuthTimeOut', AuthTimeOutError);

// invalid tenant id
cidMobileErrorMap.set('InvalidTenantId', standardErrorText + 'Invalid tenant ID.');

// needed a special function here because workflow name is dynamic
export function getCidMobileErrorString(key, workflowName, transactionId) {
  const errorString = cidMobileErrorMap.get(key);
  const transactionIdString = ( (transactionId !== undefined && transactionId !== '') ? transactionId : 'No transaction ID.');
  return errorString.replace('{workflowName}', workflowName).replace('{transactionId}', transactionIdString);
};

export { cidMobileErrorMap };
